export default "__VITE_ASSET__BEaNoWNO__"